export function classifySyncFailure(error) {
  const status = error?.response?.status;
  if (status >= 400 && status < 500) return 'permanent';
  return 'retry';
}

export function buildOfflineQueueItem(payload, { userId, outletId, tenantId, ts = Date.now() }) {
  return { ts, user_id: userId || null, outlet_id: outletId || null, tenant_id: tenantId || null, payload };
}

export function getOrCreateCartIdempotencyKey(currentKey, generator = () => crypto.randomUUID()) {
  return currentKey || generator();
}
